export default __webpack_public_path__ + "static/media/logo_ANZOR.c5d87f61.svg";